import styled from 'styled-components';
import Card from '@material-ui/core/Card';
export const CardStyleApplication = styled.div`
  margin-top: 16px;
  background: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05), 0 0px 40px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  background: white;
  padding: 16px 16px 0px 24px;
`;
export const TableCellStyle = styled.div`
  max-width: 2px;
  padding: 5px 10px;
  font-size: 11px;
`;
export const ApplicationTitle = styled.div`
  margin: 0;
  font-family: 'OpenSans-Regular';
  font-size: 17px;
  color: black;
  opacity: 0.9;
`;
export const StyledUserLevelCard = styled(Card)`
  margin-top: 16px;
  background-color: #fff;
  height: 80vh;
  min-height: 640px;
`;
export const StyledTabPanel = styled.div`
  background-color: #fff;
  height: 100%;
`;
export const StyledAppbar = styled.div`
  background-color: #fff;
  height: 100%;
`;
export const TabWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export default {
  CardStyleApplication,
  TableCellStyle,
  ApplicationTitle,
  TabWrapper
};